import React from "react";
import { FormControl, FormLabel } from "@mui/material";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { outlinedFieldStyles } from "./fieldStyles";

export default function CustomTimePicker({
  title, label, required, onChange, disabled, minTime, maxTime, values, ampm = false,
}) {
  const value = typeof values === "string"
    ? dayjs(`2000-01-01T${values}`)
    : values;

  return (
    <FormControl fullWidth>
      {(title || required) && <FormLabel>
        {title}{required && <span className="text-danger"> *</span>}
      </FormLabel>}
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <TimePicker
          value={value?.isValid?.() ? value : null}
          onChange={onChange} ampm={ampm} disabled={disabled || false}
          label={label} minTime={minTime} maxTime={maxTime}
          slotProps={{ textField: { size: "small", fullWidth: true } }}
          sx={outlinedFieldStyles}
        />
      </LocalizationProvider>
    </FormControl>
  );
}
